export const TIME = 'time';
export const HOURS = 'hours';
export const HOUR = 'hour';
export const MINUTES = 'minutes';
export const MINUTE = 'minute';
export const DAY = 'day';
export const MONTH = 'month';
export const YEAR = 'year';
export const YYYY = 'YYYY';
export const DDD_DD_MMM = 'ddd DD MMM';
export const DDD_DD_MMM_YYYY = 'ddd DD MMM YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const YYYY_MM = 'YYYY-MM';
export const DD_MMMM_YYYY = 'DD MMMM YYYY';
export const MMMM_D_YYYY = 'MMMM D, YYYY';
export const MMM_D_YYYY = 'MMM D, YYYY';
export const DD_MMM_YYY = 'DD MMM YYYY';
export const YYYY_MM_DD_HH_MM = 'YYYY-MM-DD HH:mm';
export const HH = 'HH';
export const H_M = 'h:m';
export const ONE_DAY_FORMAT = 'D';
export const MMM = 'MMMM';
export const HH_MM = 'HH:mm';
export const DDDD_MMMM_D = 'dddd, MMMM D';
export const DDD = 'ddd';
export const DD = 'dd';
export const D = 'd';
export const MM = 'mm';
export const uninterruptedSchedule = '00:00-00:00';
export const DD_MM_YYYY_HH_MM = 'DD-MM-YYYY HH:mm';
export const DD_MM_YYYY_HH_MM_DOT = 'DD.MM.YYYY HH:mm';
export const FOOL_DATE_FORMAT_UTC = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const FOOL_DATE_FORMAT_UTC_PLUS = 'YYYY-MM-DDTHH:mm:ssZ[Z]';
export const FOOL_DATE_FORMAT_MERIDIEM = 'MM/DD/YYYY h:mm A';
export const DD_MM_YYYY = 'DD.MM.YYYY';
export const DD_MM_YYYY_SLASH = 'DD/MM/YYYY';
export const MM_DD_YYYY_SLASH = 'MM/DD/YYYY';
export const MM_DD_YYYY = 'MM.DD.YYYY';
export const MM_DD_YYYY_HH_MM_SLASH = 'MM/DD/YYYY HH:mm';
export const YYYY_MM_DD_DOT = 'YYYY.MM.DD';
export const DATES_SET_CAMEL = 'datesSet';
export const DETERMINATE = 'determinate';
export const LONG = 'long';
export const NUMERIC = 'numeric';
export const TODAY = 'today';
export const START = 'start';
export const MERIDIEM_AM = 'am';
export const MERIDIEM_PM = 'pm';
export const MERIDIEM_HOUR_FORMAT = 'h:mm a';
export const ZERO_TIME = '00:00';
